/**
 * @generated SignedSource<<0d328681bee877cd8ca8315a058fb2f6>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type UpdateStateFilter = "ACTIVE" | "AT_RISK" | "CANCELLED" | "DONE" | "NO_UPDATE" | "OFF_TRACK" | "ON_TRACK" | "PAUSED" | "PENDING";
export type GoalUpdatesViewQuery$variables = {
  endDate?: string | null;
  prevDate?: string | null;
  startDate?: string | null;
  stateFilter?: UpdateStateFilter | null;
  workspaceId: string;
};
export type GoalUpdatesViewQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"GoalUpdatesMainColumn">;
};
export type GoalUpdatesViewQuery = {
  response: GoalUpdatesViewQuery$data;
  variables: GoalUpdatesViewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "endDate"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "prevDate"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "startDate"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "stateFilter"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "workspaceId"
},
v5 = {
  "kind": "Variable",
  "name": "endDate",
  "variableName": "endDate"
},
v6 = {
  "kind": "Variable",
  "name": "startDate",
  "variableName": "startDate"
},
v7 = {
  "kind": "Variable",
  "name": "stateFilter",
  "variableName": "stateFilter"
},
v8 = {
  "kind": "Variable",
  "name": "workspaceId",
  "variableName": "workspaceId"
},
v9 = [
  {
    "kind": "ScalarField",
    "name": "count"
  }
],
v10 = {
  "kind": "ScalarField",
  "name": "id"
},
v11 = [
  {
    "kind": "Variable",
    "name": "createdAfter",
    "variableName": "startDate"
  },
  {
    "kind": "Variable",
    "name": "createdBefore",
    "variableName": "endDate"
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 10
  },
  (v7/*: any*/),
  (v8/*: any*/)
],
v12 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v13 = {
  "kind": "ScalarField",
  "name": "uuid"
},
v14 = {
  "kind": "ScalarField",
  "name": "aaid"
},
v15 = {
  "kind": "ScalarField",
  "name": "picture"
},
v16 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v17 = {
  "kind": "ScalarField",
  "name": "name"
},
v18 = {
  "kind": "ScalarField",
  "name": "accountStatus"
},
v19 = {
  "kind": "ScalarField",
  "name": "ari"
},
v20 = [
  (v10/*: any*/)
],
v21 = {
  "kind": "ScalarField",
  "name": "key"
},
v22 = {
  "kind": "ScalarField",
  "name": "creationDate"
},
v23 = {
  "kind": "ScalarField",
  "name": "value"
},
v24 = [
  (v23/*: any*/),
  (v10/*: any*/)
],
v25 = {
  "kind": "ScalarField",
  "name": "type"
},
v26 = {
  "kind": "ScalarField",
  "name": "subType"
},
v27 = {
  "kind": "ScalarField",
  "name": "archived"
},
v28 = [
  (v25/*: any*/),
  {
    "kind": "ScalarField",
    "name": "percentage"
  }
],
v29 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 3
  }
],
v30 = {
  "kind": "ScalarField",
  "name": "editDate"
},
v31 = {
  "args": [
    {
      "kind": "Literal",
      "name": "includeScore",
      "value": false
    }
  ],
  "kind": "ScalarField",
  "name": "label",
  "storageKey": "label(includeScore:false)"
},
v32 = [
  {
    "kind": "ScalarField",
    "name": "messageId"
  }
],
v33 = {
  "concreteType": "LocalizationField",
  "kind": "LinkedField",
  "name": "localizedLabel",
  "plural": false,
  "selections": (v32/*: any*/)
},
v34 = {
  "kind": "ScalarField",
  "name": "score"
},
v35 = {
  "concreteType": "CompletionGoalState",
  "kind": "LinkedField",
  "name": "atCompletionState",
  "plural": false,
  "selections": [
    (v31/*: any*/),
    (v33/*: any*/),
    (v23/*: any*/),
    (v34/*: any*/)
  ]
},
v36 = [
  {
    "kind": "Literal",
    "name": "longFormat",
    "value": true
  }
],
v37 = [
  {
    "kind": "ScalarField",
    "name": "confidence"
  },
  {
    "kind": "ScalarField",
    "name": "label"
  },
  (v33/*: any*/),
  {
    "alias": "tooltip",
    "args": (v36/*: any*/),
    "kind": "ScalarField",
    "name": "label",
    "storageKey": "label(longFormat:true)"
  },
  {
    "alias": "localizedTooltip",
    "args": (v36/*: any*/),
    "concreteType": "LocalizationField",
    "kind": "LinkedField",
    "name": "localizedLabel",
    "plural": false,
    "selections": (v32/*: any*/),
    "storageKey": "localizedLabel(longFormat:true)"
  },
  {
    "kind": "ScalarField",
    "name": "overdue"
  }
],
v38 = {
  "kind": "ScalarField",
  "name": "summary"
},
v39 = [
  {
    "kind": "ScalarField",
    "name": "active"
  },
  {
    "kind": "ScalarField",
    "name": "missed"
  },
  {
    "kind": "ScalarField",
    "name": "atRisk"
  },
  {
    "kind": "ScalarField",
    "name": "onTrack"
  },
  {
    "kind": "ScalarField",
    "name": "offTrack"
  },
  {
    "kind": "ScalarField",
    "name": "done"
  },
  {
    "kind": "ScalarField",
    "name": "cancelled"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "name": "GoalUpdatesViewQuery",
    "selections": [
      {
        "args": [
          (v5/*: any*/),
          {
            "kind": "Variable",
            "name": "prevDate",
            "variableName": "prevDate"
          },
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "GoalUpdatesMainColumn"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/),
      (v4/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "GoalUpdatesViewQuery",
    "selections": [
      {
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": [
          {
            "args": [
              (v8/*: any*/)
            ],
            "concreteType": "GoalConnection",
            "kind": "LinkedField",
            "name": "goalsWatching",
            "plural": false,
            "selections": (v9/*: any*/)
          },
          (v10/*: any*/)
        ]
      },
      {
        "args": (v11/*: any*/),
        "concreteType": "UpdateConnection",
        "kind": "LinkedField",
        "name": "allWatchedGoalUpdates",
        "plural": false,
        "selections": [
          {
            "concreteType": "UpdateEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              (v12/*: any*/),
              {
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v12/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v10/*: any*/),
                      (v13/*: any*/),
                      {
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "creator",
                        "plural": false,
                        "selections": [
                          (v14/*: any*/),
                          (v10/*: any*/),
                          {
                            "concreteType": "UserPII",
                            "kind": "LinkedField",
                            "name": "pii",
                            "plural": false,
                            "selections": [
                              (v15/*: any*/),
                              (v16/*: any*/),
                              (v17/*: any*/),
                              (v18/*: any*/)
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "name": "missedUpdate"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "updateType"
                      },
                      (v19/*: any*/),
                      {
                        "concreteType": "Goal",
                        "kind": "LinkedField",
                        "name": "goal",
                        "plural": false,
                        "selections": [
                          (v19/*: any*/),
                          (v13/*: any*/),
                          {
                            "concreteType": "Workspace",
                            "kind": "LinkedField",
                            "name": "workspace",
                            "plural": false,
                            "selections": [
                              (v13/*: any*/),
                              (v10/*: any*/)
                            ]
                          },
                          (v10/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "watching"
                          },
                          {
                            "concreteType": "TownsquareGoalCapabilities",
                            "kind": "LinkedField",
                            "name": "capabilities",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "canWatchGoal"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "canCommentOnUpdates"
                              }
                            ]
                          },
                          {
                            "concreteType": "Goal",
                            "kind": "LinkedField",
                            "name": "parentGoal",
                            "plural": false,
                            "selections": (v20/*: any*/)
                          },
                          (v21/*: any*/),
                          (v17/*: any*/),
                          {
                            "concreteType": "GoalIcon",
                            "kind": "LinkedField",
                            "name": "icon",
                            "plural": false,
                            "selections": [
                              (v21/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "appearance"
                              }
                            ]
                          },
                          {
                            "concreteType": "GoalUpdate",
                            "kind": "LinkedField",
                            "name": "latestUserUpdate",
                            "plural": false,
                            "selections": [
                              (v10/*: any*/),
                              (v22/*: any*/)
                            ]
                          },
                          {
                            "kind": "ScalarField",
                            "name": "latestUpdateDate"
                          },
                          {
                            "concreteType": "GoalConnection",
                            "kind": "LinkedField",
                            "name": "subGoals",
                            "plural": false,
                            "selections": (v9/*: any*/)
                          },
                          {
                            "concreteType": "MetricTargetConnection",
                            "kind": "LinkedField",
                            "name": "metricTargets",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "MetricTargetEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "MetricTarget",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "startValue"
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "targetValue"
                                      },
                                      (v10/*: any*/),
                                      {
                                        "concreteType": "MetricValue",
                                        "kind": "LinkedField",
                                        "name": "snapshotValue",
                                        "plural": false,
                                        "selections": (v24/*: any*/)
                                      },
                                      {
                                        "concreteType": "Metric",
                                        "kind": "LinkedField",
                                        "name": "metric",
                                        "plural": false,
                                        "selections": [
                                          (v10/*: any*/),
                                          (v17/*: any*/),
                                          (v25/*: any*/),
                                          (v26/*: any*/),
                                          (v27/*: any*/),
                                          {
                                            "kind": "ScalarField",
                                            "name": "source"
                                          },
                                          {
                                            "concreteType": "MetricValue",
                                            "kind": "LinkedField",
                                            "name": "latestValue",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "kind": "ScalarField",
                                                "name": "time"
                                              },
                                              (v10/*: any*/)
                                            ]
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          },
                          {
                            "concreteType": "GoalProgress",
                            "kind": "LinkedField",
                            "name": "progress",
                            "plural": false,
                            "selections": (v28/*: any*/)
                          },
                          {
                            "args": (v29/*: any*/),
                            "concreteType": "TagConnection",
                            "kind": "LinkedField",
                            "name": "tagsWatchedByUser",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TagEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "Tag",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v10/*: any*/),
                                      (v17/*: any*/),
                                      (v13/*: any*/),
                                      {
                                        "kind": "ScalarField",
                                        "name": "description"
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "projectUsageCount"
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "goalUsageCount"
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "helpPointerUsageCount"
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "watcherCount"
                                      }
                                    ]
                                  }
                                ]
                              }
                            ],
                            "storageKey": "tagsWatchedByUser(first:3)"
                          },
                          {
                            "args": (v29/*: any*/),
                            "concreteType": "TeamConnection",
                            "kind": "LinkedField",
                            "name": "teamsWatchedByUser",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TeamEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "Team",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v10/*: any*/),
                                      (v17/*: any*/),
                                      {
                                        "kind": "ScalarField",
                                        "name": "teamId"
                                      }
                                    ]
                                  }
                                ]
                              }
                            ],
                            "storageKey": "teamsWatchedByUser(first:3)"
                          }
                        ]
                      },
                      (v22/*: any*/),
                      {
                        "concreteType": "GoalMetricUpdateConnection",
                        "kind": "LinkedField",
                        "name": "metricUpdate",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "GoalMetricUpdateEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "GoalMetricUpdate",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "newStartValue"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "newTargetValue"
                                  },
                                  {
                                    "concreteType": "MetricValue",
                                    "kind": "LinkedField",
                                    "name": "newValue",
                                    "plural": false,
                                    "selections": (v24/*: any*/)
                                  },
                                  {
                                    "concreteType": "Metric",
                                    "kind": "LinkedField",
                                    "name": "metric",
                                    "plural": false,
                                    "selections": [
                                      (v10/*: any*/),
                                      (v17/*: any*/),
                                      (v25/*: any*/),
                                      (v26/*: any*/),
                                      (v27/*: any*/)
                                    ]
                                  },
                                  {
                                    "concreteType": "MetricValue",
                                    "kind": "LinkedField",
                                    "name": "oldValue",
                                    "plural": false,
                                    "selections": (v24/*: any*/)
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "concreteType": "GoalProgress",
                        "kind": "LinkedField",
                        "name": "newProgress",
                        "plural": false,
                        "selections": (v28/*: any*/)
                      },
                      {
                        "concreteType": "CommentConnection",
                        "kind": "LinkedField",
                        "name": "comments",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "CommentEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "Comment",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v10/*: any*/),
                                  (v30/*: any*/),
                                  (v19/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "commentText"
                                  },
                                  (v22/*: any*/),
                                  {
                                    "concreteType": "User",
                                    "kind": "LinkedField",
                                    "name": "creator",
                                    "plural": false,
                                    "selections": [
                                      (v14/*: any*/),
                                      {
                                        "concreteType": "UserPII",
                                        "kind": "LinkedField",
                                        "name": "pii",
                                        "plural": false,
                                        "selections": [
                                          (v15/*: any*/),
                                          (v17/*: any*/),
                                          (v18/*: any*/),
                                          (v16/*: any*/)
                                        ]
                                      },
                                      (v10/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ]
                          },
                          {
                            "kind": "ClientExtension",
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "__id"
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "lastEditedBy",
                        "plural": false,
                        "selections": [
                          (v14/*: any*/),
                          {
                            "concreteType": "UserPII",
                            "kind": "LinkedField",
                            "name": "pii",
                            "plural": false,
                            "selections": [
                              (v17/*: any*/)
                            ]
                          },
                          (v10/*: any*/)
                        ]
                      },
                      (v30/*: any*/),
                      {
                        "alias": "newGoalState",
                        "concreteType": "GoalState",
                        "kind": "LinkedField",
                        "name": "newState",
                        "plural": false,
                        "selections": [
                          (v23/*: any*/),
                          (v31/*: any*/),
                          (v33/*: any*/),
                          (v34/*: any*/),
                          (v35/*: any*/)
                        ]
                      },
                      {
                        "concreteType": "TargetDate",
                        "kind": "LinkedField",
                        "name": "newDueDate",
                        "plural": false,
                        "selections": (v37/*: any*/)
                      },
                      (v38/*: any*/),
                      {
                        "concreteType": "UpdateNote",
                        "kind": "LinkedField",
                        "name": "notes",
                        "plural": true,
                        "selections": [
                          (v27/*: any*/),
                          (v13/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "title"
                          },
                          (v38/*: any*/),
                          (v10/*: any*/)
                        ]
                      },
                      {
                        "concreteType": "TargetDate",
                        "kind": "LinkedField",
                        "name": "oldDueDate",
                        "plural": false,
                        "selections": (v37/*: any*/)
                      },
                      {
                        "alias": "oldGoalState",
                        "concreteType": "GoalState",
                        "kind": "LinkedField",
                        "name": "oldState",
                        "plural": false,
                        "selections": [
                          (v31/*: any*/),
                          (v33/*: any*/),
                          (v34/*: any*/),
                          (v23/*: any*/),
                          (v35/*: any*/)
                        ]
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "concreteType": "Project",
                                "kind": "LinkedField",
                                "name": "project",
                                "plural": false,
                                "selections": [
                                  (v21/*: any*/),
                                  (v10/*: any*/)
                                ]
                              }
                            ],
                            "type": "ProjectUpdate"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "url"
                              }
                            ],
                            "type": "GoalUpdate"
                          }
                        ],
                        "type": "Update",
                        "abstractKey": "__isUpdate"
                      }
                    ],
                    "type": "GoalUpdate"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v20/*: any*/),
                    "type": "Node",
                    "abstractKey": "__isNode"
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "name": "cursor"
              }
            ]
          },
          {
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "endCursor"
              },
              {
                "kind": "ScalarField",
                "name": "hasNextPage"
              }
            ]
          }
        ]
      },
      {
        "args": (v11/*: any*/),
        "filters": [
          "workspaceId",
          "createdBefore",
          "createdAfter",
          "stateFilter"
        ],
        "handle": "connection",
        "key": "GoalUpdatesList_allWatchedGoalUpdates",
        "kind": "LinkedHandle",
        "name": "allWatchedGoalUpdates"
      },
      {
        "alias": "currentSummary",
        "args": [
          (v5/*: any*/),
          (v6/*: any*/),
          (v8/*: any*/)
        ],
        "concreteType": "StatusSummary",
        "kind": "LinkedField",
        "name": "goalStatusSummary",
        "plural": false,
        "selections": (v39/*: any*/)
      },
      {
        "alias": "previousSummary",
        "args": [
          {
            "kind": "Variable",
            "name": "endDate",
            "variableName": "startDate"
          },
          {
            "kind": "Variable",
            "name": "startDate",
            "variableName": "prevDate"
          },
          (v8/*: any*/)
        ],
        "concreteType": "StatusSummary",
        "kind": "LinkedField",
        "name": "goalStatusSummary",
        "plural": false,
        "selections": (v39/*: any*/)
      }
    ]
  },
  "params": {
    "cacheID": "aaa0b5ba7502ee0d54751e4eff7b23e1",
    "id": null,
    "metadata": {},
    "name": "GoalUpdatesViewQuery",
    "operationKind": "query",
    "text": "query GoalUpdatesViewQuery(\n  $prevDate: DateTime\n  $startDate: DateTime\n  $endDate: DateTime\n  $workspaceId: ID!\n  $stateFilter: UpdateStateFilter\n) {\n  ...GoalUpdatesMainColumn_2SEHUt\n}\n\nfragment Comment on Comment {\n  id\n  ari\n  commentText\n  creationDate\n  editDate\n  creator {\n    aaid\n    ...UserAvatar\n    id\n  }\n}\n\nfragment Comments on CommentConnection {\n  edges {\n    node {\n      id\n      editDate\n      ...Comment\n    }\n  }\n}\n\nfragment GoalDateChanged on GoalUpdate {\n  oldDueDate {\n    ...TargetDate\n  }\n  newDueDate {\n    ...TargetDate\n  }\n}\n\nfragment GoalFollowButton on Goal {\n  id\n  uuid\n  watching\n  capabilities {\n    canWatchGoal\n  }\n}\n\nfragment GoalMissedUpdateLabel on GoalUpdate {\n  creationDate\n  missedUpdate\n  updateType\n  goal {\n    id\n    key\n    latestUserUpdate {\n      id\n      creationDate\n    }\n    latestUpdateDate\n  }\n}\n\nfragment GoalProgressChanged on GoalUpdate {\n  metricUpdate {\n    edges {\n      node {\n        metric {\n          type\n          subType\n          archived\n          id\n        }\n        newStartValue\n        newValue {\n          value\n          id\n        }\n        oldValue {\n          value\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment GoalState on GoalState {\n  label(includeScore: false)\n  localizedLabel {\n    messageId\n  }\n  score\n  value\n  atCompletionState {\n    label(includeScore: false)\n    localizedLabel {\n      messageId\n    }\n    value\n    score\n  }\n}\n\nfragment GoalStatusChanged on GoalUpdate {\n  newGoalState: newState {\n    ...GoalState\n  }\n  oldGoalState: oldState {\n    ...GoalState\n  }\n}\n\nfragment GoalUpdateCardByline on Goal {\n  watching\n  tagsWatchedByUser(first: 3) {\n    edges {\n      node {\n        ...Tag\n        id\n      }\n    }\n  }\n  teamsWatchedByUser(first: 3) {\n    edges {\n      node {\n        id\n        name\n        teamId\n      }\n    }\n  }\n}\n\nfragment GoalUpdateCardFooter on GoalUpdate {\n  id\n  ari\n  updateType\n  missedUpdate\n  goal {\n    ari\n    ...GoalFollowButton\n    id\n  }\n  ...ShareUpdateButton\n}\n\nfragment GoalUpdateCardHeader on GoalUpdate {\n  id\n  goal {\n    ...GoalFollowButton\n    parentGoal {\n      id\n    }\n    key\n    name\n    ...PlatformGoalIcon\n    id\n  }\n}\n\nfragment GoalUpdateCardInternal on GoalUpdate {\n  id\n  ari\n  uuid\n  goal {\n    ari\n    uuid\n    workspace {\n      uuid\n      id\n    }\n    id\n  }\n  ...GoalUpdateCardHeader\n  ...GoalUpdateCardTop\n  ...GoalUpdateSummary\n  notes {\n    ...UpdateNote\n    id\n  }\n  ...GoalUpdateDiff\n  ...GoalUpdateCardFooter\n  comments {\n    ...Comments\n  }\n}\n\nfragment GoalUpdateCardProgress on GoalUpdate {\n  metricUpdate {\n    edges {\n      node {\n        newStartValue\n        newTargetValue\n        newValue {\n          value\n          id\n        }\n        metric {\n          id\n          name\n          type\n          subType\n          archived\n        }\n      }\n    }\n  }\n  newProgress {\n    type\n    percentage\n  }\n  goal {\n    id\n    subGoals {\n      count\n    }\n    metricTargets {\n      edges {\n        node {\n          startValue\n          targetValue\n          id\n        }\n      }\n    }\n    ...MetricChart\n  }\n}\n\nfragment GoalUpdateCardTop on GoalUpdate {\n  ari\n  creator {\n    ...UserAvatar_2aqwkz\n    ...UserName\n    id\n  }\n  ...GoalUpdateCreationDate\n  ...GoalUpdateStatus\n  ...GoalMissedUpdateLabel\n  ...GoalUpdateCardProgress\n}\n\nfragment GoalUpdateCardTop_PTxnb on GoalUpdate {\n  ari\n  creator {\n    ...UserAvatar_2aqwkz\n    ...UserName\n    id\n  }\n  ...GoalMissedUpdateLabel\n  missedUpdate\n  ...GoalUpdateCardProgress\n}\n\nfragment GoalUpdateCard_3UosK1 on GoalUpdate {\n  id\n  uuid\n  creator {\n    aaid\n    id\n  }\n  missedUpdate\n  updateType\n  ...MissedGoalUpdateCard\n  ...GoalUpdateCardInternal\n  goal {\n    uuid\n    ...GoalUpdateCardByline\n    id\n  }\n}\n\nfragment GoalUpdateCreationDate on GoalUpdate {\n  id\n  goal {\n    key\n    id\n  }\n  creator {\n    aaid\n    id\n  }\n  lastEditedBy {\n    aaid\n    pii {\n      name\n    }\n    id\n  }\n  missedUpdate\n  creationDate\n  editDate\n}\n\nfragment GoalUpdateDiff on GoalUpdate {\n  ...GoalDateChanged\n  ...GoalStatusChanged\n  ...GoalProgressChanged\n}\n\nfragment GoalUpdateStatus on GoalUpdate {\n  newGoalState: newState {\n    value\n    ...GoalState\n  }\n  newDueDate {\n    ...TargetDate\n  }\n}\n\nfragment GoalUpdateSummary on GoalUpdate {\n  summary\n}\n\nfragment GoalUpdatesFeed_2SEHUt on Query {\n  currentUser {\n    goalsWatching(workspaceId: $workspaceId) {\n      count\n    }\n    id\n  }\n  ...GoalUpdatesList_1j3MN4\n  ...GoalUpdatesStatusSummary_2oYDyA\n  currentSummary: goalStatusSummary(startDate: $startDate, endDate: $endDate, workspaceId: $workspaceId) {\n    atRisk\n    onTrack\n    offTrack\n    missed\n    done\n    cancelled\n  }\n}\n\nfragment GoalUpdatesList_1j3MN4 on Query {\n  allWatchedGoalUpdates(workspaceId: $workspaceId, first: 10, createdBefore: $endDate, createdAfter: $startDate, stateFilter: $stateFilter) {\n    edges {\n      node {\n        __typename\n        ...GoalUpdateCard_3UosK1\n        ... on GoalUpdate {\n          id\n          goal {\n            id\n            capabilities {\n              canCommentOnUpdates\n            }\n          }\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment GoalUpdatesMainColumn_2SEHUt on Query {\n  currentUser {\n    goalsWatching(workspaceId: $workspaceId) {\n      count\n    }\n    id\n  }\n  allWatchedGoalUpdates(workspaceId: $workspaceId, first: 10, createdBefore: $endDate, createdAfter: $startDate, stateFilter: $stateFilter) {\n    edges {\n      __typename\n    }\n  }\n  ...GoalUpdatesFeed_2SEHUt\n}\n\nfragment GoalUpdatesStatusSummary_2oYDyA on Query {\n  currentSummary: goalStatusSummary(startDate: $startDate, endDate: $endDate, workspaceId: $workspaceId) {\n    active\n    missed\n    atRisk\n    onTrack\n    offTrack\n    done\n    cancelled\n  }\n  previousSummary: goalStatusSummary(startDate: $prevDate, endDate: $startDate, workspaceId: $workspaceId) {\n    active\n    missed\n    atRisk\n    onTrack\n    offTrack\n    done\n    cancelled\n  }\n}\n\nfragment MetricChart on Goal {\n  ...WrappedWithMetricPopup\n  id\n  progress {\n    type\n    percentage\n  }\n  subGoals {\n    count\n  }\n  metricTargets {\n    edges {\n      node {\n        ...common_metricTarget_direct\n        metric {\n          source\n          latestValue {\n            time\n            id\n          }\n          id\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment MissedGoalUpdateCard on GoalUpdate {\n  id\n  ari\n  uuid\n  goal {\n    ari\n    uuid\n    workspace {\n      uuid\n      id\n    }\n    id\n  }\n  ...GoalUpdateCardHeader\n  ...GoalUpdateCardTop_PTxnb\n  ...GoalUpdateCardFooter\n  comments {\n    ...Comments\n  }\n}\n\nfragment PlatformGoalIcon on Goal {\n  icon {\n    key\n    appearance\n  }\n}\n\nfragment ShareUpdateButton on Update {\n  __isUpdate: __typename\n  ... on ProjectUpdate {\n    id\n  }\n  ... on GoalUpdate {\n    id\n  }\n  ...ShareUpdateDialogContent\n}\n\nfragment ShareUpdateDialogContent on Update {\n  __isUpdate: __typename\n  ... on ProjectUpdate {\n    id\n    project {\n      key\n      id\n    }\n  }\n  ... on GoalUpdate {\n    id\n    url\n    goal {\n      key\n      id\n    }\n  }\n}\n\nfragment Tag on Tag {\n  ...Tag_createTagOption\n}\n\nfragment Tag_createTagOption on Tag {\n  id\n  name\n  uuid\n  description\n  projectUsageCount\n  goalUsageCount\n  helpPointerUsageCount\n  watcherCount\n}\n\nfragment TargetDate on TargetDate {\n  confidence\n  label\n  localizedLabel {\n    messageId\n  }\n  tooltip: label(longFormat: true)\n  localizedTooltip: localizedLabel(longFormat: true) {\n    messageId\n  }\n  overdue\n}\n\nfragment UpdateNote on UpdateNote {\n  archived\n  uuid\n  title\n  summary\n}\n\nfragment UserAvatar on User {\n  aaid\n  pii {\n    picture\n    name\n    accountStatus\n    accountId\n  }\n}\n\nfragment UserAvatar_2aqwkz on User {\n  aaid\n  pii {\n    picture\n    accountId\n  }\n}\n\nfragment UserName on User {\n  aaid\n  pii {\n    name\n    accountStatus\n  }\n}\n\nfragment WrappedWithMetricPopup on Goal {\n  id\n  progress {\n    type\n    percentage\n  }\n  metricTargets {\n    edges {\n      node {\n        ...common_metricTarget_direct\n        metric {\n          archived\n          id\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment common_metricTarget_direct on MetricTarget {\n  startValue\n  targetValue\n  snapshotValue {\n    value\n    id\n  }\n  metric {\n    id\n    name\n    type\n    subType\n  }\n}\n"
  }
};
})();

(node as any).hash = "03f2743f5c014f04ec16b86f238c71df";

export default node;
